import { defineStore } from 'pinia'
import { simple } from '@/api/home/index'
import router from '@/router'

export const useUserInfoStore = defineStore(
  'userInfo',
  () => {
    const initialized = ref(false)
    const userData = ref(null)
    const initializing = ref(false)

    const simpleApi = async () => {
      initializing.value = true
      try {
        const res = await simple()
        initialized.value = true
        let { data } = res
        localStorage.setItem('userInfo', JSON.stringify({ userData: data }))
        userData.value = data
        if (!data) {
          router.push('/poster')
        } else if ([1, 2, 99].includes(data.promoterStatus)) {
          router.push('/certification')
        } else if (data.promoterStatus == 0) {
          // router.push('/home')
        }
      } finally {
        initializing.value = false
      }
    }

    const getInitialized = () => {
      return initialized.value
    }

    const getUserData = () => {
      return userData.value
    }

    const initialize = async () => {
      if (initialized.value || initializing.value) return
      await simpleApi()
    }

    const removeAll = () => {
      initialized.value = false
      userData.value = null
    }

    return {
      userData,
      simpleApi,
      initialize,
      getUserData,
      getInitialized,
      removeAll,
    }
  },
  {
    // 添加持久化配置
    persist: true,
  },
)
